import actions from "./actions";
import mutations from "./mutations";
const state = {
  categories: [],
  subcategories: [],
  jobs: [],
  vendors: [],
  adminUser: {}
};

const noAuth = {
  namespaced: true,
  state,
  actions,
  mutations
};

export default noAuth;
